import React, { HTMLAttributes, PropsWithChildren, ReactNode } from 'react';
import { getFilteredClasses } from '../../utils';
import styles from './styles.module.scss';

const Container = ({ children, className, ...rest }: HTMLAttributes<HTMLDivElement>) => {
  const filteredClasses = getFilteredClasses(['container my-4', className]);

  return (
    <div className={filteredClasses} role="main" {...rest}>
      <div className={styles.container}>{children}</div>
    </div>
  );
};

const Body = ({ children }: HTMLAttributes<HTMLDivElement>) => <div className={`col-12 ${styles.body}`}>{children}</div>;

const Footer = ({ children }: HTMLAttributes<HTMLDivElement>) => <div className={`d-flex align-items-center justify-content-end ${styles.footer}`}>{children}</div>;

const Header = ({ children, icon, title }: PropsWithChildren<{ icon?: ReactNode; title: string }>) => (
  <div className={`d-flex justify-content-between ${styles.header}`}>
    <div className="d-flex align-items-center">
      {icon}
      <h1 className={`h5 ${styles.title}`}>{title}</h1>
    </div>
    {children}
  </div>
);

Container.Body = Body;
Container.Footer = Footer;
Container.Header = Header;

export { Container };
